// ======================================================================
// File Name       : participant
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import * as ActionTypes from '../../constants/actionTypes/participant';

export function storeParticipantList(
  userSearchResult,
  groupRelationList,
  groupInfo,
  eachUserLiveCountList,
) {
  return {
    type: ActionTypes.STORE_PARTICIPANT_LIST,
    userSearchResult,
    groupRelationList,
    groupInfo,
    eachUserLiveCountList,
  };
}

export function storeParticipantDetail(
  userSearchResult,
  groupRelationList,
  groupInfo,
) {
  return {
    type: ActionTypes.STORE_PARTICIPANT_DETAIL,
    userSearchResult,
    groupRelationList,
    groupInfo,
  };
}

export function storeParticipantDetailStatus(
  liverSearchResult,
  liveList,
  liveStatusInfo,
  userSearchRes,
) {
  return {
    type: ActionTypes.STORE_PARTICIPANT_DETAIL_STATUS,
    liverSearchResult,
    liveList,
    liveStatusInfo,
    userSearchRes,
  };
}

export function resetParticipantDetail() {
  return {
    type: ActionTypes.RESET_PARTICIPANT_DETAIL,
  };
}
